(function () {
  'use strict';

  // 1. YouTube Facade：点击替换为真实 iframe
  document.querySelectorAll('.pdp-video__facade').forEach(function (facade) {
    facade.addEventListener('click', function () {
      var ytId = facade.dataset.ytId;
      if (!ytId) return;

      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + ytId + '?autoplay=1&rel=0&modestbranding=1';
      iframe.allow = 'autoplay; encrypted-media; fullscreen';
      iframe.allowFullscreen = true;
      iframe.setAttribute('style', 'position:absolute;inset:0;width:100%;height:100%;border:none;');

      var poster = facade.querySelector('.pdp-video__poster');
      var btn    = facade.querySelector('.pdp-video__play-btn');
      if (poster) poster.remove();
      if (btn)    btn.remove();

      facade.appendChild(iframe);
      facade.classList.remove('pdp-video__facade');
    });
  });

  // 2. Intersection Observer：非首屏 <video> 懒加载
  if ('IntersectionObserver' in window) {
    var lazyVideos = document.querySelectorAll('.pdp-video__player[preload="none"]');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.load();
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px 0px' });

    lazyVideos.forEach(function (v) { observer.observe(v); });
  }
})();
